"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowValues = exports.windowValuesPlugin = exports.windowValuesLogic = void 0;
var kea_1 = require("kea");
exports.windowValuesLogic = (0, kea_1.kea)({
    path: function () { return ['kea', 'windowValues', 'logic']; },
    actions: function () { return ({
        syncWindowValues: function (windowValues) { return ({ windowValues: windowValues }); },
    }); },
});
var windowValuesPlugin = function (_a) {
    var _b = _a.window, windowObject = _b === void 0 ? window : _b;
    return ({
        name: 'windowValues',
        events: {
            afterPlugin: function () {
                (0, kea_1.setPluginContext)('windowValues', {
                    windowObject: windowObject,
                    eventListener: undefined,
                    mounted: {},
                });
            },
            afterReduxStore: function () {
                exports.windowValuesLogic.mount();
            },
            beforeCloseContext: function () {
                var eventListener = getWindowValuesPluginContext().eventListener;
                if (eventListener) {
                    windowObject.document.removeEventListener('scroll', eventListener, true);
                    windowObject.removeEventListener('resize', eventListener);
                }
            },
            legacyBuildAfterDefaults: function (logic, input) {
                'windowValues' in input && input.windowValues && windowValues(input.windowValues)(logic);
            },
        },
    });
};
exports.windowValuesPlugin = windowValuesPlugin;
function windowValues(input) {
    return function (logic) {
        var windowObject = getWindowValuesPluginContext().windowObject;
        var windowValuesInput = typeof input === 'function' ? input(logic) : input;
        logic.cache.windowValuesInput = __assign(__assign({}, (logic.cache.windowValuesInput || {})), windowValuesInput);
        (0, kea_1.reducers)(function (logic) {
            var reducers = {};
            Object.entries(windowValuesInput).forEach(function (_a) {
                var _b;
                var key = _a[0], inputParams = _a[1];
                var calcFunction = Array.isArray(inputParams) ? inputParams[1] : inputParams;
                var defaultValue = Array.isArray(inputParams) ? inputParams[0] : function () { return calcFunction(windowObject); };
                reducers[key] = [
                    defaultValue,
                    (_b = {},
                        _b[exports.windowValuesLogic.actionTypes.syncWindowValues] = function (state, _a) {
                            var _b;
                            var windowValues = _a.windowValues;
                            var value = (_b = windowValues === null || windowValues === void 0 ? void 0 : windowValues[logic.pathString]) === null || _b === void 0 ? void 0 : _b[key];
                            return typeof value === 'undefined' ? state : value;
                        },
                        _b),
                ];
            });
            return reducers;
        })(logic);
        (0, kea_1.afterMount)(function (logic) {
            var windowObject = getWindowValuesPluginContext().windowObject;
            if (!logic.cache.windowValuesInput || typeof windowObject === 'undefined') {
                return;
            }
            var pluginContext = getWindowValuesPluginContext();
            pluginContext.mounted[logic.pathString] = function (hasOld) {
                if (hasOld === void 0) { hasOld = false; }
                var updates = {};
                Object.entries(logic.cache.windowValuesInput).forEach(function (_a) {
                    var key = _a[0], inputParams = _a[1];
                    var calcFunction = Array.isArray(inputParams) ? inputParams[1] : inputParams;
                    var oldValue = hasOld ? logic.values[key] : null;
                    var newValue = calcFunction(windowObject);
                    if (!hasOld || oldValue !== newValue) {
                        updates[key] = newValue;
                    }
                });
                return Object.keys(updates).length > 0 ? updates : null;
            };
            if (!pluginContext.eventListener) {
                pluginContext.eventListener = function () {
                    var response = {};
                    Object.entries(pluginContext.mounted).forEach(function (_a) {
                        var pathString = _a[0], windowFunction = _a[1];
                        var value = windowFunction === null || windowFunction === void 0 ? void 0 : windowFunction();
                        if (value) {
                            response[pathString] = value;
                        }
                    });
                    if (Object.keys(response).length > 0) {
                        exports.windowValuesLogic.actions.syncWindowValues(response);
                    }
                };
                windowObject.document.addEventListener('scroll', pluginContext.eventListener, true);
                windowObject.addEventListener('resize', pluginContext.eventListener);
            }
        })(logic);
        (0, kea_1.beforeUnmount)(function (logic) {
            var windowObject = getWindowValuesPluginContext().windowObject;
            if (!logic.cache.windowValuesInput || typeof windowObject === 'undefined') {
                return;
            }
            var _a = getWindowValuesPluginContext(), mounted = _a.mounted, eventListener = _a.eventListener;
            delete mounted[logic.pathString];
            if (eventListener && Object.keys(mounted).length === 0) {
                windowObject.document.removeEventListener('scroll', eventListener, true);
                windowObject.removeEventListener('resize', eventListener);
            }
        })(logic);
    };
}
exports.windowValues = windowValues;
function getWindowValuesPluginContext() {
    return (0, kea_1.getPluginContext)('windowValues');
}
//# sourceMappingURL=index.js.map